<div>
  {{ text }}
</div>

@if (isShowAnimation) {
  <img
    src="/assets/images/ui/loading/loading-animation.gif"
    alt="loading" />
}
